import React, {useContext, useEffect, useState} from "react";
import {Container, Button, InputGroup, Modal, Spinner, Card, Row, Col, Form} from "react-bootstrap";
import {store} from "../../../Store/store";
import {SET_USER_PREFERENCES} from "../../../Store/ActionTypes/General/actionTypes";
import {useMutation} from "@apollo/client";
import {SET_COST_PREFERENCES} from "../../../GraphQL/ReportGenerator/queries";
import {FcCheckmark} from 'react-icons/fc';
import {BiError} from 'react-icons/bi';

export default function SettingsModal(props) {
    const {dispatch} = useContext(store);

    const data = props.data;

    const volumeUnitOptions = [
        {value: 'LITERS', label: 'Liter'},
        {value: 'GALLONS', label: 'Gallon'},
        {value: 'CCF', label: 'CCF'},
        {value: 'CUBIC_METERS', label: 'Cubic Meter'},
    ];
    const volumeUnitSelectOptions = volumeUnitOptions.map(option => {
        return (
            <option key={option.value} value={option.value}>
                {option.label}
            </option>
        )
    });
    const volumeUnitOptionsMap = volumeUnitOptions.reduce((map, item) => {
        map.set(item.value, item.label);
        return map;
    }, new Map());

    const currencyOptions = [
        {value: 'ILS', label: 'ILS'},
        {value: 'USD', label: 'USD'},
        {value: 'EUR', label: 'EUR'},
        {value: 'GBP', label: 'GBP'}
    ];
    const currencySelectOptions = currencyOptions.map(option => {
        return (
            <option key={option.value} value={option.value}>
                {option.label}
            </option>
        )
    });

    const [setUserPreference, {mutationData, loading, error}] = useMutation(SET_COST_PREFERENCES);

    const [selectedVolumeUnit, setSelectedVolumeUnit] = useState(data.volumeUnit);
    const [selectedCostVolumeUnit, setSelectedCostVolumeUnit] = useState(data.costVolumeUnit);
    const [selectedCurrency, setSelectedCurrency] = useState(data.currencyUnit);
    const [waterPrice, setWaterPrice] = useState(data.waterPrice);
    const [saved, setSaved] = useState(false);
    const [saveButtonText, setSaveButtonText] = useState('Save');

    useEffect(() => {
        const timeId = setTimeout(() => {
            setSaved(false);
            setSaveButtonText('Save');
        }, 3000);

        return () => {
            clearTimeout(timeId)
        }
    }, [saved]);

    const onWaterPriceChanged = (event) => {
        let newWaterPrice = event.target.value;
        setWaterPrice(newWaterPrice);
    }

    const submitSettings = () => {
        dispatch({
            type: SET_USER_PREFERENCES,
            payload: {
                volumeMeasUnitOptions: selectedVolumeUnit,
                currencyUnits: selectedCurrency,
                waterPrice: waterPrice
            }
        });

        setUserPreference({
            variables: {
                userPreferences: {
                    "currencyUnit": selectedCurrency,
                    "waterPrice": waterPrice,
                    "costVolumeUnit": selectedCostVolumeUnit,
                    "flowrateUnit": "LITERS_PER_HOUR",
                    "volumeUnit": selectedVolumeUnit
                },
            }
        }).then(setSaved(true))
            .then(setSaveButtonText('Saved!'));
    }

    return (
        <Modal size="lg" dialogClassName={'modal-settings'} show={props.show} backdrop={true} onHide={() => props.setShow(false)} className={'SettingModal'}>
            <Modal.Header closeButton>
                <Modal.Title>Settings</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Container>
                    <Row>
                        <Col md={6}>
                            <Card>
                                <Card.Header>
                                    <Card.Title>Display Values</Card.Title>
                                </Card.Header>
                                <Card.Body>
                                    <Form>
                                        <Form.Label>Volume Unit</Form.Label>
                                        <Form.Control as="select" value={selectedVolumeUnit} onChange={option => setSelectedVolumeUnit(option.target.value)}>
                                            {volumeUnitSelectOptions}
                                        </Form.Control>
                                        <Form.Text muted>All volumes are based on this unit.</Form.Text>
                                    </Form>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col md={6}>
                            <Card>
                                <Card.Header>
                                    <Card.Title>Cost Values</Card.Title>
                                </Card.Header>
                                <Card.Body>
                                    <Form>
                                        <Form.Group>
                                            <Form.Label>Volume Unit</Form.Label>
                                            <Form.Control as="select" value={selectedCostVolumeUnit} onChange={option => setSelectedCostVolumeUnit(option.target.value)}>
                                                {volumeUnitSelectOptions}
                                            </Form.Control>
                                            <Form.Text muted>Volume unit used for cost calculation.</Form.Text>
                                        </Form.Group>
                                        <Form.Group>
                                            <Form.Label>Currency</Form.Label>
                                            <Form.Control as="select" value={selectedCurrency} onChange={option => setSelectedCurrency(option.target.value)}>
                                                {currencySelectOptions}
                                            </Form.Control>
                                        </Form.Group>
                                        <Form.Label>Default Water Price</Form.Label>
                                        <InputGroup>
                                            <Form.Control value={waterPrice} onChange={event => onWaterPriceChanged(event)}/>
                                            <InputGroup.Text>{`${selectedCurrency} / ${volumeUnitOptionsMap.get(selectedCostVolumeUnit)}`}</InputGroup.Text>
                                        </InputGroup>
                                    </Form>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </Modal.Body>
            <Modal.Footer>
                {loading && <Spinner animation="border" variant="primary"/>}
                {!loading && <Button variant={'aqua'} onClick={() => submitSettings()}> {saveButtonText} </Button>}
                {saved && !loading && !error && <p style={{display: "contents", fontSize: "x-large"}}><FcCheckmark/></p>}
                {error && !loading && <p style={{display: "contents", fontSize: "x-large"}}><BiError/></p>}
                <Button variant="secondary" onClick={() => props.setShow(false)}>Close</Button>
            </Modal.Footer>
        </Modal>
    )
}